import { forwardRef, Inject, Pipe, PipeTransform } from '@angular/core';
import { CustomLabelService } from '../../service/custom-label.service';

@Pipe({ name: 'customLabel', pure: false })
export class CustomLabelPipe implements PipeTransform {

    private customLabels;

    constructor(
        @Inject(forwardRef(() => CustomLabelService)) private customLabelService: CustomLabelService
    ) {
        this.customLabelService.customLabels$.subscribe(customLabels => this.customLabels = customLabels);
    }

    transform(key: any): string {
        return this.customLabels[key] ? this.customLabels[key] : key;
    }
}
